import analytics from './index';

interface MediaDownloadProperties {
  asset_url: string;
  asset_title: string;
  content_type: string;
  page_url: string;
  page_path: string;
  file_extension: string;
  file_size_bytes?: number;
  component_location?: string;
}

export function getAssetUrl(rawUrl: string): string {
  return rawUrl.startsWith('http') ? rawUrl : `https:${rawUrl}`;
}

function getFileExtension(url: string): string {
  try {
    const pathname = new URL(url).pathname;
    const ext = pathname.split('.').pop();
    return ext ?? '';
  } catch {
    const ext = url.split('.').pop()?.split('?')[0];
    return ext ?? '';
  }
}

export function trackMediaDownload({
  assetUrl,
  assetTitle,
  contentType,
  fileSizeBytes,
  componentLocation
}: {
  assetUrl: string;
  assetTitle: string;
  contentType: string;
  fileSizeBytes?: number;
  componentLocation?: string;
}): void {
  const url = getAssetUrl(assetUrl);

  const properties: MediaDownloadProperties = {
    asset_url: url,
    asset_title: assetTitle,
    content_type: contentType,
    page_url: globalThis.window ? globalThis.window.location.href : '',
    page_path: globalThis.window ? globalThis.window.location.pathname : '',
    file_extension: getFileExtension(url),
    ...(fileSizeBytes != null && { file_size_bytes: fileSizeBytes }),
    ...(componentLocation && { component_location: componentLocation })
  };

  analytics.track('Media Downloaded', properties);
}
